import { useState, useEffect } from "react";
const useEvolutionChain = (pokemonName) => {
  const [evolutionData, setEvolutionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getEvolutionChain = async () => {
      if (!pokemonName) return;
      try {
        setLoading(true);
        setError(false);
        /* i'm gonna fetch single pokemon information */
        const pokemonRes = await fetch(
          `https://pokeapi.co/api/v2/pokemon/${pokemonName}`
        );
        if (!pokemonRes.ok) throw new Error("Pokémon not found");
        const pokemonData = await pokemonRes.json();

        /* fetch species in order to obtain chain evolution  */
        const speciesURL = pokemonData.species.url;
        const speciesRes = await fetch(speciesURL);
        if (!speciesRes.ok) throw new Error("Species data not found ˙◠˙ ");
        const speciesData = await speciesRes.json();

        // 3. Consulta la URL de la cadena de evolución
        const evolutionURL = speciesData.evolution_chain.url;
        const resEvolutionURL = await fetch(evolutionURL);
        if (!resEvolutionURL.ok) throw new Error("Evolution data not found");
        const evolutionData = await resEvolutionURL.json();

        setEvolutionData(evolutionData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    getEvolutionChain();
  }, [pokemonName]);
  return { evolutionData, loading, error };
};

export default useEvolutionChain;
